import Icon from '../components/Icon.vue'

Icon.register({
  'flag-usa': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M32 0c17.7 0 32 14.3 32 32v464c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-464c0-17.7 14.3-32 32-32zM299.9 303.6c31.1 8.2 62.6 16.5 100 16.6 31.9 0 68.5-6.8 112.1-24.1v36c0 12.3-7.1 23.8-18.5 28.8-175.8 76.4-211.8-69.1-397.5 23.1v-69.3c92.2-39.9 146.7-26.2 203.9-11.1zM299.9 207.6c31.1 8.2 62.6 16.5 100 16.5 31.9 0 68.5-6.8 112.1-24.1v61.5c-92.2 39.9-146.7 26.2-203.9 11.1-57.5-15.1-117.3-30-212.1 7.6v-61.5c92.2-39.9 146.7-26.2 203.9-11.1zM309.4 81.7c-7-2.1-14.1-4.2-21.3-6.2v33.2c4 1.1 8.1 2.3 12.1 3.5 26.7 8.1 52.9 15.9 85.7 15.9 32.8 0 72.5-7.9 126.1-31.4v68.9c-92.2 39.8-146.7 26.1-203.9 11.1-57.5-15.1-117.3-29.9-212.1 7.6v-151.9c209.4-94.6 195.3 59.1 366.6-28.2 22.6-11.5 49.4 1.5 49.4 26.6v30.8c-105.2 49.1-150.8 35.7-202.6 20.1zM160 128.1c8.8 0 16-7.1 16-16 0-8.9-7.2-16-16-16s-16 7.2-16 16c0 8.9 7.2 16 16 16zM160 72.3c8.8 0 16-7.2 16-16 0-8.9-7.2-16-16-16s-16 7.2-16 16c0 8.9 7.2 16 16 16zM224 120.2c8.8 0 16-7.2 16-16 0-8.9-7.2-16-16-16s-16 7.2-16 16c0 8.9 7.2 16 16 16zM224 64.3c8.8 0 16-7.2 16-16 0-8.9-7.2-16-16-16s-16 7.2-16 16c0 8.9 7.2 16 16 16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/flag-usa.js
// module id = 1359
// module chunks = 0